import { setInitialState } from "../../../../utils/reducerOperations";
export function Default() {
    return {
        storyboardFetchDriversDataApi: setInitialState(),
        storyboardLowOutcomeQuestionScoreApi:setInitialState(),
    };
}
